import React, { useState } from 'react';
import styled from 'styled-components';

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  width: ${({ isMaximized, isMinimized }) => (isMaximized ? '100%' : isMinimized ? '80%' : '80%')};
  height: ${({ isMaximized, isMinimized }) => (isMaximized ? '100%' : isMinimized ? '80%' : '80%')};
  background-color: #fff;
  border-radius: ${({ isMaximized }) => (isMaximized ? '0' : '8px')};
  overflow: hidden;
  box-shadow: ${({ isMaximized }) => (isMaximized ? 'none' : '0 4px 10px rgba(0, 0, 0, 0.3)')};
  display: flex;
  flex-direction: column;
  position: relative;
  transition: all 0.3s ease;
`;

const ModalHeader = styled.div`
  background-color: #f4f4f4;
  padding: 10px 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  font-family: 'JetBrains Mono Regular';
`;

const ControlButtons = styled.div`
  display: flex;
  gap: 8px;
`;

const ControlButton = styled.button`
  background: none;
  border: 1px solid transparent;
  font-size: 14px;
  cursor: pointer;
  font-family: 'JetBrains Mono Regular';
  padding: 5px 10px;
  border-radius: 4px;

  ${({ color }) => color && `color: ${color};`}
  ${({ color }) => color && `border-color: ${color};`}

  &:hover {
    opacity: 0.8;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

const ModalIframe = styled.iframe`
  flex-grow: 1;
  border: none;
  display: ${({ isMinimized }) => (isMinimized ? 'block' : 'block')};
`;

const Tooltip = styled.div`
  visibility: hidden;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  margin-left: -200%;
  bottom: -70px;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  min-width: 400px;
  z-index: 99999;

  ::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }
`;

const ControlButtonWithTooltip = styled(ControlButton)`
  position: relative;

  &:hover ${Tooltip} {
    visibility: visible;
    opacity: 1;
  }
`;

const PopUp = ({ isModalOpen, handleCloseModal }) => {
  const [isMaximized, setMaximized] = useState(false);
  const [isMinimized, setMinimized] = useState(false);

  const handleMaximize = () => {
    setMaximized(true);
    setMinimized(false);
  };

  const handleMinimize = () => {
    setMaximized(false);
    setMinimized(true);
  };

  const handleRestore = () => {
    setMaximized(false);
    setMinimized(false);
  };

  const handleOpenExternalSite = () => {
    window.open('https://search.titlesqld.com.au/product-search', '_blank');
  };

  const isDefaultSize = !isMaximized && !isMinimized;

  return (
    <div>
      {isModalOpen && (
        <ModalContainer>
          <ModalContent isMaximized={isMaximized} isMinimized={isMinimized}>
            <ModalHeader>
              <span>Website Preview</span>
              <ControlButtons>
                {!isMaximized && (
                  <ControlButton onClick={handleMaximize} color="green" disabled={isMaximized}>
                    Maximize
                  </ControlButton>
                )}
                {isMaximized && (
                  <ControlButton onClick={handleRestore} color="green">
                    Restore
                  </ControlButton>
                )}
                <ControlButton onClick={handleMinimize} color="grey" disabled={isDefaultSize}>
                  Minimize
                </ControlButton>
                <ControlButton onClick={handleCloseModal} color="red">
                  Close
                </ControlButton>
                <ControlButtonWithTooltip onClick={handleOpenExternalSite} color="blue">
                  Go to External Site
                  <Tooltip>
                    Due to browser cross-site blocking, if you ca&apos;t purchase tiles, click this
                    to open the site in a new tab.
                  </Tooltip>
                </ControlButtonWithTooltip>
              </ControlButtons>
            </ModalHeader>
            <ModalIframe
              src="https://search.titlesqld.com.au/product-search"
              title="Website Preview"
              isMinimized={isMinimized}
            />
          </ModalContent>
        </ModalContainer>
      )}
    </div>
  );
};

export default PopUp;
